<template>
  <hc-table :tableData="state.specialTaskTable" :column="state.specialColumn" :isHidePage="true" />
</template>

<script setup>
import hcTable from "@/components/hc-home/table.vue";
import { pageListApi as taskSubmitRecordApi } from "@/api/task/submitRecord.js";
import { onMounted, reactive } from "vue";
import { usePageI18n } from "@/composables/usePageI18n.js";
import { applySpecialTodoColumns } from "@/utils/homeDashboardI18n.js";

const state = reactive({
  specialTaskTable: [],
  specialColumn: [
    { type: "index", label: "序号", width: 60 },
    { prop: "real_name", label: "提交人" },
    { prop: "username", label: "用户名" },
    { prop: "created_at", label: "创建时间", width: 160 },
  ],
})

const applyLabels = () => {
  applySpecialTodoColumns(state.specialColumn)
}
const { t } = usePageI18n(applyLabels)

const getAuditList = () => {
  taskSubmitRecordApi(JSON.stringify({
    page: 1,
    limit: 8,
    status: 1,
    keywords: ""
  })).then(res => {
    state.specialTaskTable = res?.data ?? []
  })
};

onMounted(() => {
  applyLabels()
  getAuditList()
})
</script>
